import { useState } from 'react'

import { SnackbarConfigTypes } from '../../commons/utils/Types'
import { useUserContext } from '../../context/UserContext'
import { Client } from '../../models/Client'
import { getClientByLegacyCode } from '../API/ClientsAPI'
import ClientSearchView from './ClientSearchView'

function ClientSearchContainer(): JSX.Element {
    const { mill } = useUserContext()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [legacyCode, setLegacyCode] = useState<string>('')
    const [client, setClient] = useState<Client | null>(null)
    const [snackbarConfig, setSnackBarConfig] = useState<SnackbarConfigTypes>({
        message: '',
        isVisible: false,
        status: 'success',
    })

    const handleCloseSnackbar = () => {
        setSnackBarConfig({
            ...snackbarConfig,
            isVisible: false,
        })
    }

    const handleLegacyCodeChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setLegacyCode(event.target.value)
    }

    const handleSearch = async () => {
        if (!legacyCode.trim()) {
            setSnackBarConfig({
                message: 'Por favor, informe o código do cliente',
                isVisible: true,
                status: 'warning',
            })
            return
        }

        if (!mill?.id) {
            setSnackBarConfig({
                message: 'Erro: ID da fábrica não encontrado',
                isVisible: true,
                status: 'error',
            })
            return
        }

        setIsLoading(true)
        try {
            const response = await getClientByLegacyCode(legacyCode, mill.id)
            if (response) {
                setClient(response)
                setSnackBarConfig({
                    message: 'Cliente encontrado com sucesso',
                    isVisible: true,
                    status: 'success',
                })
            } else {
                setClient(null)
                setSnackBarConfig({
                    message: 'Cliente não encontrado',
                    isVisible: true,
                    status: 'error',
                })
            }
        } catch (error) {
            setClient(null)
            setSnackBarConfig({
                message: 'Erro ao buscar cliente',
                isVisible: true,
                status: 'error',
            })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <ClientSearchView
            isLoading={isLoading}
            legacyCode={legacyCode}
            client={client}
            snackbarConfig={snackbarConfig}
            handleCloseSnackbar={handleCloseSnackbar}
            handleLegacyCodeChange={handleLegacyCodeChange}
            handleSearch={handleSearch}
        />
    )
}

export default ClientSearchContainer
